import { useEffect } from 'react';
import { useMutation } from '@tanstack/react-query';
import { APP_NAME } from '~/shared/constants';
import { postAuthLogin, postAuthLogout, postAuthPasswordReset, postAuthSignup } from '~/generated/authBackend/auth';
import {
    type InternalApiHttpAuthLoginRequest,
    type InternalApiHttpAuthPasswordResetRequest,
    type InternalApiHttpAuthSignupRequest,
} from '~/generated/authBackend/model';
import { loginSucceeded, logoutSucceeded } from './events';

export const useLogin = () => {
    const mutation = useMutation({
        mutationFn: async (payload: InternalApiHttpAuthLoginRequest) => {
            return await postAuthLogin(payload, {
                app: APP_NAME,
            });
        },
    });

    useEffect(() => {
        if (mutation.data) {
            loginSucceeded(mutation.data);
        }
    }, [mutation.data]);

    return mutation;
};

export const useSignup = () => {
    return useMutation({
        mutationFn: async (payload: InternalApiHttpAuthSignupRequest) => {
            return await postAuthSignup(payload);
        },
    });
};

export const useLogout = () => {
    const mutation = useMutation({
        mutationFn: postAuthLogout,
    });

    useEffect(() => {
        if (mutation.isSuccess) {
            logoutSucceeded();
        }
    }, [mutation.isSuccess]);

    return mutation;
};

export const useResetPassword = () => {
    return useMutation({
        mutationFn: async (payload: InternalApiHttpAuthPasswordResetRequest) => {
            return await postAuthPasswordReset(payload);
        },
    });
};
